import React from "react";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import BaseConfig from '@xem/look/utils/fieldConfig';
import fontOptions from "@gqlapp/qrcode/utils/fonts";
import addMap from "@xem/entity-client-react/helpers/addMap";
import { shiftOfObject } from "@gqlapp/utils/filterObject";
import RenderDropdownField from "@xem/look/Renders/Field/Dropdown";
import Checked from "@xem/icon/base/Checked.svg";

/**
 * Import
 */
import FrameThumb0 from "./icons/frame0.svg";
import FrameThumb1 from "./icons/frame1.svg";
import FrameThumb2 from "./icons/frame2.svg";
import FrameThumb3 from "./icons/frame3.svg";
import FrameThumb4 from "./icons/frame4.svg";
import FrameThumb5 from "./icons/frame5.svg";
import FrameThumb6 from "./icons/frame6.svg";
import FrameThumb7 from "./icons/frame7.svg";
import FrameThumb8 from "./icons/frame8.svg";
import FrameThumb9 from "./icons/frame9.svg";
import FrameThumb10 from "./icons/frame10.svg";
import FrameThumb11 from "./icons/frame11.svg";
import FrameThumb12 from "./icons/frame12.svg";
import FrameThumb13 from "./icons/frame13.svg";
import FrameThumb14 from "./icons/frame14.svg";
import FrameThumb15 from "./icons/frame15.svg";
import FrameThumb16 from "./icons/frame16.svg";
import FrameThumb17 from "./icons/frame17.svg";
import FrameThumb18 from "./icons/frame18.svg";
import FrameThumb19 from "./icons/frame19.svg";
import FrameThumb20 from "./icons/frame20.svg";
import FrameThumb21 from "./icons/frame21.svg";
import FrameThumb22 from "./icons/frame22.svg";
import FrameThumb23 from "./icons/frame23.svg";
import FrameThumb24 from "./icons/frame24.svg";
import FrameCircle from "./icons/circle.svg";

 /**
 * BaseField
 * @param onActions
 * @param append
 * @constructor
 */
 export function BaseField({ onActions, append: funcAppend }){
	 /**
	  *
	  */
	 return function BaseField({ title, name, value, label: valueLabel, items }){
		 let menus = [{ type: 'group', items }]
		 let append = func(funcAppend)()
		 
		 const sx = {
			 '& div[data-modal-header] > div.header-inner, & div[data-modal-scroll], & div[data-modal-scroll] > div[data-modal-body]':{
				 margin: 0,
				 backgroundColor: '#ffffff'
			 },
			 '& div[data-modal-scroll] > div[data-modal-body]':{
				 padding: '0 15px',
				 '& .btn': {
					 border: 'none',
					 '& .row':{
						 minHeight: '40px',
						 '& > .col, & > .col-auto': {
							 display: 'inline-flex',
							 whiteSpace: 'nowrap',
							 alignItems: 'center'
						 }
					 }
				 }
			 }
		 }
		 
		 /*** BaseConfig */
		 return BaseConfig({
			 name,
			 label: title,
			 value: valueLabel,
			 component: RenderDropdownField,
			 onClick: function onClick(){
				 func(onActions['clicks'])({
					 selectProps:{ webType: 'web' },
					 sx, append, enableClose: true,
					 title, value, items: menus
				 })
			 }
		 });
	 }
 }


/**
 *
 * @param props
 */
export function fontConfig(props: any){
	const Base = BaseField(props);
	let { site, setFieldValue } = props;
	
	return function fontConfig({ value, name }) {
		value = value || 'Roboto';
		
		let items = [];
		let def = [items, [setFieldValue, name, {
			withoutChange: true,
			wrapper: ({ children })=><>{children}</>
		}], value, null];
		
		fontOptions.map((name, value)=>addMap(...def, name, (function ({ isActive }){
			return (<Row medium sx={{ fontFamily: `${name}` }}>
				<Col className={'ellipsis ellipsis-one'}>{name}</Col>
				<Col xs={'auto'}>{site?.name}</Col>
				<Col xs={'auto'} sx={{ width: '40px'}}>{(isActive) && <><Checked/></>}</Col>
			</Row>)
		})))
		
		let label = value;
		return Base({
			items, name, value, label,
			title: 'qr:qrcode.font.title'.t()
		})
	}
	
}




/**
 * Frame
 * @type {({icon: *})[]}
 */
export const Frame: any = [
	{ frame: 'default', icon: FrameThumb0, fontFamily: "0", disableText: true },
	{ frame: 'frame1', icon: FrameThumb1, font: "0", width: 1000, height: 200, maxFontSize: 200 },
	{ frame: 'frame2', icon: FrameThumb2, font: "1", width: 800, height: 200 },
	{ frame: 'frame3', icon: FrameThumb3, font: "2", width: 1000, height: 200 },
	{ frame: 'frame4', icon: FrameThumb4, font: "3", width: 1000, height: 200 },
	{ frame: 'frame5', icon: FrameThumb5, font: "4", width: 1000, height: 200 },
	{ frame: 'frame6', icon: FrameThumb6, font: "5", width: 1000, height: 200 },
	{ frame: 'frame7', icon: FrameThumb7, font: "1", width: 1000, height: 200 },
	{ frame: 'frame8', icon: FrameThumb8, font: "2", width: 1000, height: 200 },
	{ frame: 'frame9', icon: FrameThumb9, font: "3", width: 680, height: 200 },
	{ frame: 'frame10', icon: FrameThumb10, font: "4", width: 1000, height: 200 },
	{ frame: 'frame11', icon: FrameThumb11, font: "5", width: 1000, height: 200 },
	{ frame: 'frame12', icon: FrameThumb12, font: "1", width: 1000, height: 200 },
	{ frame: 'frame13', icon: FrameThumb13, font: "2", width: 1000, height: 200 },
	{ frame: 'frame14', icon: FrameThumb14, font: "3", width: 1000, height: 200 },
	{ frame: 'frame15', icon: FrameThumb15, font: "4", width: 1000, height: 200 },
	{ frame: 'frame16', icon: FrameThumb16, font: "5", width: 1000, height: 200 },
	{ frame: 'frame17', icon: FrameThumb17, font: "0", width: 1000, height: 200 },
	{ frame: 'frame18', icon: FrameThumb18, font: "1", width: 1000, height: 200 },
	{ frame: 'frame19', icon: FrameThumb19, font: "2", width: 1000, height: 200 },
	{ frame: 'frame20', icon: FrameThumb20, font: "3", width: 1000, height: 200 },
	{ frame: 'frame21', icon: FrameThumb21, font: "3", width: 1000, height: 200 },
	{ frame: 'frame22', icon: FrameThumb22, font: "3", width: 1000, height: 200 },
	{ frame: 'frame23', icon: FrameThumb23, font: "3", width: 1000, height: 200 },
	{ frame: 'frame24', icon: FrameThumb24, font: "3", width: 1000, height: 200 },
	{ frame: 'circle', icon: FrameCircle, font: "0", isCircle: true, twoText: true, maxFontSize: 100 },
]

export function getOptions(){
	return [...Frame].map(({ icon, frame: value } )=>{
		return ({ value, icon })
	})
}

export default function getStyle(style:string){
	let _OPTS = {};
	[...Frame].sort((a, b) => {
		if (a.frame === 'default') return 1;  // a đứng sau
		if (b.frame === 'default') return -1; // b đứng sau
		return 0; // giữ nguyên thứ tự các phần tử còn lại
	}).map(({ frame, ...values })=>{
		_OPTS[frame] = Object.assign(values, { frame });
	});
	
	return shiftOfObject(_OPTS, function ($value: any, $key: string){
		return !!$value && [`${style}`, 'default'].includes($key);
	});
}